import { render, staticRenderFns } from "./order-table.vue?vue&type=template&id=69d7b4f6&scoped=true&"
import script from "./order-table.vue?vue&type=script&lang=js&"
export * from "./order-table.vue?vue&type=script&lang=js&"
import style0 from "./order-table.vue?vue&type=style&index=0&id=69d7b4f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69d7b4f6",
  null
  
)

export default component.exports